module.exports = __webpack_public_path__ + "static/005-88091136e01326e06b325065afe481a3.jpeg";